








































import Vue from 'vue'
import {TranslateResult} from "vue-i18n";

declare interface RoomTopicItem {
  text: string | TranslateResult,
  value: string,
}

export type DataType = {
  roomTopic: string,
  roomTopicItems: RoomTopicItem[],
  customTopic: string,
}

export default Vue.extend({
  name: 'CardRoomTopic',

  data(): DataType {
    return {
      roomTopic: 'random',
      roomTopicItems: [
        {
          text: this.$t('CardRoomTopic.random'),
          value: 'random',
        },
        {
          text: this.$t('CardRoomTopic.poiWorld'),
          value: 'places in world',
        },
        {
          text: this.$t('CardRoomTopic.poiEurope'),
          value: 'places in europe',
        },
        {
          text: this.$t('CardRoomTopic.poiUSA'),
          value: 'places in usa',
        },
        {
          text: this.$t('CardRoomTopic.poiRussia'),
          value: 'places in russia',
        },
        {
          text: this.$t('CardRoomTopic.poiAsia'),
          value: 'places in asien', // we need to write this otherwhise results are wrong
        },
        {
          text: this.$t('CardRoomTopic.poiAustralia'),
          value: 'places in australia',
        },
        {
          text: this.$t('CardRoomTopic.castlesEurope'),
          value: 'castles in europe',
        },
        {
          text: this.$t('CardRoomTopic.custom'),
          value: 'custom',
        },
      ],
      customTopic: '',
    }
  },

  methods: {
    setRoomTopic(): void {
      this.$emit('setRoomTopic', this.roomTopic === 'custom' ? this.customTopic : this.roomTopic)
    },

    cancel(): void {
      this.$emit('cancel')
    }
  }
})
